import {
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { memo, useState } from "react";
import { useResultadoExercicioService } from "../contexts/ResultadoExercicioContext";

const FinanceCategoryCheckBox = ({ financeCategory, level }) => {
  const { handleCheck } = useResultadoExercicioService();
  const [isChildrenOpen, setChildrenOpen] = useState(false);

  const children = financeCategory.children.map((child) => {
    return (
      <FinanceCategoryCheckBox
        financeCategory={child}
        level={level + 3}
        key={child.id}
      />
    );
  });

  return (
    <>
      <ListItem button style={{ padding: 0 }}>
        <ListItemIcon style={{ marginLeft: level * 8 }}>
          <Checkbox
            checked={financeCategory.checked}
            onChange={(event) => {
              handleCheck(financeCategory, event.target.checked);
            }}
          />
        </ListItemIcon>
        <ListItemText
          style={{ padding: "8px 0" }}
          primary={financeCategory.desc}
          onClick={() => setChildrenOpen(!isChildrenOpen)}
        />
        <ListItemIcon onClick={() => setChildrenOpen(!isChildrenOpen)}>
          {!!children.length &&
            (isChildrenOpen ? <ExpandLess /> : <ExpandMore />)}
        </ListItemIcon>
      </ListItem>
      {isChildrenOpen && children}
    </>
  );
};

export default memo(FinanceCategoryCheckBox);
